import { EventEmitter, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApplicationMode } from './application.service';

@Injectable({ providedIn: 'root' })
export class MessageService {

  public applicationMode: ApplicationMode;
  public showErrorDetail: true;
  public errorMessage = "";
  public log: EventEmitter<any>;
  public refresh = false;

  get isBusy(): boolean {
    return window["isBusy"];
  }

  constructor(
    private snackBar: MatSnackBar) {
    this.log = new EventEmitter();
  }

  public showError(message: string) {
    if (message) {
      this.snackBar.open(message, 'Dismiss', {
        duration: 8000,
        panelClass: 'error-snack'
      });
    }
  }

  public showSuccess(message: string) {
    if (message) {
      this.snackBar.open(message, 'Ok', {
        duration: 4000,
        panelClass: 'success-snack'
      });
    }
  }

  logError(request: any, error: any) {

    try {

      var data = {
        Error: error,
        Request: request
      };

      var input = JSON.stringify(data, Object.getOwnPropertyNames(data));
      if (this.log) {
        this.log.emit(input);
      }
      
    }
    catch { }

  }



}


